import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { INikkeCharacterNode } from '../../../common/model/graphql-types';
import { NikkeCharacterIcon } from './nikke-character-icon';
import { NikkeCharacterCard } from './nikke-character-card';
import { NikkeCharacterInline } from './nikke-character-inline';
import { NikkeCharacterIconTierList } from './nikke-character-icon-tier';

interface IProps {
  id?: string;
  slug: string;
  enablePopover?: boolean;
  showLabel?: boolean;
  showTags?: boolean;
  showBug?: boolean;
  showStatus?: boolean;
  onlyName?: boolean;
  showIcon?: boolean;
  mode: string;
  unitId?: string;
  variant?: string;
  tierID?: number;
  showTreasure?: boolean;
}

export const NikkeCharacter: React.FC<IProps> = ({
  id,
  unitId,
  mode,
  showLabel,
  slug,
  enablePopover,
  showTags,
  showBug,
  showStatus,
  showIcon,
  onlyName,
  tierID
}) => {
  const allNikkeCharacters = useStaticQuery(graphql`
    query {
      allContentfulNikkeCharacter {
        nodes {
          id
          updatedAt
          createdAt
          unitId
          name
          slug
          rarity
          element
          weapon
          class
          smallImage {
            localFile {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
          cardImage {
            localFile {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
          burstType
          manufacturer
          squad
          isLimited
          limitedEvent
          skills {
            cooldown
            type
            slot
          }
          isNew
          isReviewPending
          showNewOnTierList
          hasTreasure
          highInvestement
        }
      }
    }
  `);
  if ((!id && !slug && !unitId) || !mode) {
    return <div>Err</div>;
  }

  const character = allNikkeCharacters.allContentfulNikkeCharacter.nodes.find(
    (emp: INikkeCharacterNode) =>
      id ? emp.id === id : unitId ? emp.unitId === unitId : emp.slug === slug
  );

  if (!character) {
    return <div>Err</div>;
  }

  return (
    <>
      {mode === 'icon' && (
        <NikkeCharacterIcon
          employee={character}
          showLabel={showLabel}
          showTags={showTags}
          showBug={showBug}
          showStatus={showStatus}
          enablePopover={enablePopover}
          onlyName={onlyName}
        />
      )}
      {mode === 'icon-tier' && (
        <NikkeCharacterIconTierList
          employee={character}
          enablePopover={enablePopover}
          tierID={tierID}
        />
      )}
      {mode === 'inline' && (
        <NikkeCharacterInline
          employee={character}
          enablePopover={enablePopover}
        />
      )}
      {mode === 'card' && (
        <NikkeCharacterCard
          employee={character}
          showLabel={showLabel}
          showIcon={showIcon}
          showStatus={showStatus}
          showTags={showTags}
          showBug={showBug}
          enablePopover={enablePopover}
        />
      )}
    </>
  );
};
